import React from "react";
import { getFieldRefInfo } from "../ExploreTab.utils";
import useEntityOptions from "../hooks/useEntityOptions.hook";
import useEntityLabels from "../hooks/useEntityLabels.hook";
import RefCellDisplay from "./RefCellDisplay";

const EntityRefCell = ({ field, value, version, defaultLanguage, isEditable }) => {
  const refInfo = getFieldRefInfo(field);
  const { options, isLoading: optionsLoading } = useEntityOptions({
    entityType: refInfo?.entityType,
    pkFieldName: refInfo?.valueField,
    labelFieldName: refInfo?.labelField,
    version,
    defaultLanguage
  });
  const pageMatch = value ? options.find((option) => option.key === value) : null;
  const needsLabelLookup = Boolean(value) && !optionsLoading && !pageMatch;
  const entityLabels = useEntityLabels({
    entityType: refInfo?.entityType,
    pkFieldName: refInfo?.valueField,
    labelFieldName: refInfo?.labelField,
    version,
    defaultLanguage,
    enabled: needsLabelLookup
  });
  const labelMatch = entityLabels.options.find((option) => option.key === value) ?? null;
  const matchedOption = pageMatch ?? labelMatch;
  const resolvedValue = matchedOption ? matchedOption.display_key : value;
  const isResolving = Boolean(value) && !matchedOption && (optionsLoading || (needsLabelLookup && entityLabels.isLoading));

  return <RefCellDisplay field={field} resolvedValue={resolvedValue} isEditable={isEditable} isResolving={isResolving} />;
};

export default EntityRefCell;
